// import intlTelInput from "intl-tel-input";
// import "intl-tel-input/styles";
import JustValidate from 'just-validate';
import { iti } from "./internation-tel";
import { submitUpdatesForm } from "./form";
import { submitUpdateForm } from "./submit-update-form";
import { resetDropdowns, showThankYouModal, INFUSION_LOCATOR, API_KEY } from "./main";

// const initialCountryLookup = async () => {
//   const res = await fetch("https://ipapi.co/json");
//   const data = await res.json();
//   return data.country_code;
// };

// iti for facility-phone-hcp
const facilityPhoneIti = window.internationalPhoneFields?.["facility-phone-hcp"];
const form = document.querySelector("#updates-form-hcp");
let validation;
if (form) {
  validation = new JustValidate('#updates-form-hcp');
  window.hcpValidation = validation;
  const formError = document.getElementById("form-error-hcp");
  const idFormWrapper = document.querySelector('#hcp-infusion');
  validation
    .addField('#firstName-hcp', [
      {
        rule: 'required',
        errorMessage: 'First name is required',
      },
    ])
    .addField('#lastName-hcp', [
      {
        rule: 'required',
        errorMessage: 'Last name is required',
      },
    ])
    .addField('#title-hcp', [
      {
        rule: 'required',
        errorMessage: 'Please enter your title'
      },
    ])
    .addField('#email-hcp', [
      {
        rule: 'required',
        errorMessage: 'This field is required. Please input a valid email'
      },
      {
        rule: 'email',
      },
    ])

    // .addField("#phone-hcp", [
    //   {
    //     validator: (value) => {
    //       if (!value.trim()) return true;

    //       return window.internationalPhoneFields["phone-hcp"].isValidNumber();
    //     },
    //     errorMessage: "Please enter a valid phone number.",
    //   },
    // ])

    .addField('#amr-facility-hcp', [
      {
        rule: 'required',
        errorMessage: 'Please choose appropriate option',
      },
    ])
    .addField('#facility-name-hcp', [
      {
        rule: 'required',
        errorMessage: 'Name is required.'
      },
    ])
    .addField('#facility-address-1-hcp', [
      {
        rule: 'required',
        errorMessage: 'Address is required.'
      },
    ])
    .addField('#facility-city-hcp', [
      {
        rule: 'required',
        errorMessage: 'City is required.'
      },
    ])
    .addField('#facility-state-hcp', [
      {
        rule: 'required',
        errorMessage: 'State is required.'
      },
    ])
    .addField('#facility-zip-hcp', [
      {
        rule: 'required',
        errorMessage: 'ZIP Code is required',
      },
      {
        rule: 'number',
      },
      {
        rule: 'minLength',
        value: 5,
      },
      {
        rule: 'maxLength',
        value: 5,
      },
    ])
    .addField("#facility-phone-hcp", [
      {
        rule: "required",
        errorMessage: "Phone number is required.",
      },
      // {
      //   validator: (value) => {
      //     if (!value.trim()) return true;

      //     return window.internationalPhoneFields["facility-phone-hcp"].isValidNumber();
      //   },
      //   errorMessage: "Please enter a valid phone number.",
      // },
    ])
    .addField("#facility-website-hcp", [
      {
        validator: (value) => {
          if (!value.trim()) return true;

          try {
            const url = new URL(
              value.startsWith("http") ? value : `https://${value}`
            );

            return /\./.test(url.hostname);
          } catch {
            return false;
          }
        },
        errorMessage: "Please enter a valid website URL.",
      },
    ])
    .addField('#hcp-consent', [
      {
        rule: 'required',
        errorMessage: 'This field is required. Please check it.'
      },
    ])
    .onFail(() => {
      formError.style.display = "block";
      formError.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    })
    .onValidate(({ isValid }) => {
      if (isValid) {
        formError.style.display = "none";
      }
    })
    .onSuccess(async (event) => {
      formError.style.display = "none";
      event.preventDefault();
      await submitUpdateForm(event.target);
      idFormWrapper.innerHTML =
        `<div class="confirmation-message request-facility-success">
              <h2 class="text-[#ff4e00!important] text-[2rem] md:text-[3rem] text-center">Thank you, your request has
                been submitted
                and will be
                processed
                within 5
                business days.</h2>
          </div> `;
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }, 50);
    });
}

let phoneValidationActivated = false;

// if (validation) {
//   validation.onFail(() => {
//     phoneValidationActivated = true;
//   });

//   ["phone-hcp", "facility-phone-hcp"].forEach((id) => {
//     const input = document.getElementById(id);

//     if (input) {
//       ["input", "countrychange", "blur"].forEach((event) => {
//         input.addEventListener(event, async () => {
//           if (!phoneValidationActivated) return;

//           await validation.revalidateField(`#${id}`);
//         });
//       });
//     }
//   });
// }

const amrInput = document.querySelector("#amr-facility-hcp");
const amrSelect = document.querySelector(".field.custom-select");
const facilityNameInput = document.querySelector("#facility-name-hcp");
const facilityNameSuggestions = document.querySelector(".facility-name-hcp-list");
const facilityLatitudeInput = document.querySelector("#facility-latitude-hcp");
const facilityLongitudeInput = document.querySelector("#facility-longitude-hcp");
const facilityStateInput = document.querySelector("#facility-state-hcp");
const facilityStateDropdown = document.querySelector("#state-dropdown");
let facilitySearchTimeout;
let facilitySearchController;
let facilityDetailController;

const clearFacilitySuggestions = () => {
  if (!facilityNameSuggestions) return;

  facilityNameSuggestions.replaceChildren();
  facilityNameSuggestions.classList.add("hidden");
};

const resetFacilityFields = () => {
  [
    facilityNameInput,
    document.querySelector("#facility-address-1-hcp"),
    document.querySelector("#facility-address-2-hcp"),
    document.querySelector("#facility-city-hcp"),
    facilityStateInput,
    document.querySelector("#facility-zip-hcp"),
    document.querySelector("#facility-phone-hcp"),
    document.querySelector("#facility-website-hcp"),
    facilityLatitudeInput,
    facilityLongitudeInput,
  ].forEach((field) => {
    if (field) field.value = "";
  });

  ["#facility-city-hcp", "#facility-zip-hcp"].forEach((selector) => {
    const field = document.querySelector(selector);
    field?.classList.remove("pointer-events-none", "bg-[#eee!important]");
    field?.parentElement?.classList.remove("cursor-not-allowed");
  });

  const stateSelect = facilityStateDropdown?.closest(".custom-select");
  if (stateSelect) {
    stateSelect.querySelector(".select-trigger")?.classList.remove(
      "pointer-events-none",
      "bg-[#eee!important]",
    );
    stateSelect.classList.remove("cursor-not-allowed");
    stateSelect.querySelector(".selected-value").textContent = "Select a state";
    stateSelect.querySelectorAll('[role="option"]').forEach((option) => {
      option.classList.remove("selected");
    });
  }
};

const revalidateHcpFields = (...selectors) => {
  if (!window.hcpValidation) return;

  const validations = selectors.map((selector) =>
    window.hcpValidation.revalidateField(selector)
  );
  void Promise.allSettled(validations);
};

const populateFacilityDetails = (responseData) => {
  const facilityDetails = Array.isArray(responseData)
    ? responseData[0]
    : responseData;
  if (!facilityDetails || typeof facilityDetails !== "object") return;

  const fieldMap = {
    FacilityAddress1: "#facility-address-1-hcp",
    FacilityAddress2: "#facility-address-2-hcp",
    FacilityCity: "#facility-city-hcp",
    FacilityPhone: "#facility-phone-hcp",
    FacilityWebsite: "#facility-website-hcp",
    FacilityZIPCode: "#facility-zip-hcp",
  };

  Object.entries(fieldMap).forEach(([responseKey, selector]) => {
    const field = document.querySelector(selector);
    if (field) field.value = facilityDetails[responseKey] ?? "";
  });

  if (facilityStateInput && facilityStateDropdown && facilityDetails.FacilityState) {
    const stateValue = String(facilityDetails.FacilityState).trim().toLowerCase();
    const stateOption = [...facilityStateDropdown.querySelectorAll('[role="option"]')]
      .find((option) =>
        option.dataset.value?.trim().toLowerCase() === stateValue ||
        option.textContent.trim().toLowerCase() === stateValue
      );

    if (stateOption && !stateOption.hasAttribute("disabled")) {
      facilityStateInput.value = stateOption.dataset.value;
      facilityStateDropdown
        .closest(".custom-select")
        ?.querySelector(".selected-value")
        ?.replaceChildren(document.createTextNode(stateOption.textContent.trim()));
      facilityStateDropdown.querySelectorAll('[role="option"]').forEach((option) => {
        option.classList.toggle("selected", option === stateOption);
      });
    }
  }

  if (facilityDetails.Lat != null) facilityLatitudeInput.value = facilityDetails.Lat;
  if (facilityDetails.Lng != null) facilityLongitudeInput.value = facilityDetails.Lng;

  revalidateHcpFields(
    "#facility-address-1-hcp",
    "#facility-city-hcp",
    "#facility-zip-hcp",
    "#facility-state-hcp",
    "#facility-phone-hcp",
  );
};

const selectFacilitySuggestion = async (facility) => {
  facilityNameInput.value = facility.FacilityName;
  facilityLatitudeInput.value = facility.lat || "";
  facilityLongitudeInput.value = facility.lng || "";
  clearFacilitySuggestions();
  revalidateHcpFields("#facility-name-hcp");

  const facilityId = facility.id || facility.acnt_id;
  if (!facilityId) return;

  facilityDetailController?.abort();
  const controller = new AbortController();
  facilityDetailController = controller;

  try {
    const response = await fetch(
      `${INFUSION_LOCATOR}/search/${encodeURIComponent(facilityId)}`,
      {
        headers: { "x-api-key": API_KEY },
        signal: controller.signal,
      },
    );

    if (!response.ok) {
      throw new Error(`Facility details lookup failed with status ${response.status}`);
    }

    const result = await response.json();
    if (controller.signal.aborted) return;

    const responseData = result?.data ?? result;
    populateFacilityDetails(responseData);
  } catch (error) {
    if (error.name !== "AbortError") {
      console.error(error);
    }
  }
};

if (amrInput && facilityNameInput && facilityNameSuggestions) {
  facilityNameInput.addEventListener("input", () => {
    clearTimeout(facilitySearchTimeout);
    facilitySearchController?.abort();
    facilityDetailController?.abort();

    const searchText = facilityNameInput.value.trim();
    const requestType = amrInput.value;
    clearFacilitySuggestions();
    if ((requestType !== "Modify" && requestType !== "Remove") || searchText.length <= 2) return;

    facilitySearchTimeout = setTimeout(async () => {
      if (
        (amrInput.value !== "Modify" && amrInput.value !== "Remove") ||
        facilityNameInput.value.trim() !== searchText ||
        facilityNameInput.value.trim().length <= 2
      ) {
        return;
      }

      const controller = new AbortController();
      facilitySearchController = controller;

      try {
        const searchUrl = `${INFUSION_LOCATOR}/search?searchText=${encodeURIComponent(searchText)}`;
        const response = await fetch(searchUrl, {
          headers: { "x-api-key": API_KEY },
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error(`Facility search failed with status ${response.status}`);
        }

        const result = await response.json();
        if (
          controller.signal.aborted ||
          facilityNameInput.value.trim() !== searchText ||
          (amrInput.value !== "Modify" && amrInput.value !== "Remove")
        ) {
          return;
        }

        const facilities = Array.isArray(result.data) ? result.data : [];
        facilities.forEach((facility) => {
          if (!facility.FacilityName) return;

          const option = document.createElement("li");
          option.setAttribute("role", "option");
          option.tabIndex = 0;
          option.textContent = facility.FacilityName;
          option.addEventListener("click", () => selectFacilitySuggestion(facility));
          option.addEventListener("keydown", (event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              selectFacilitySuggestion(facility);
            }
          });
          facilityNameSuggestions.appendChild(option);
        });

        if (facilityNameSuggestions.childElementCount > 0) {
          facilityNameSuggestions.classList.remove("hidden");
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error(error);
          clearFacilitySuggestions();
        }
      }
    }, 300);
  });
}

if (amrSelect && amrInput) {
  amrSelect.querySelectorAll(".select-options li").forEach(option => {
    option.addEventListener("click", async () => {
      amrInput.value = option.dataset.value;
      form.querySelectorAll("input[disabled]").forEach((input) => {
        input.removeAttribute("disabled");
      });
      clearTimeout(facilitySearchTimeout);
      facilitySearchController?.abort();
      facilityDetailController?.abort();
      clearFacilitySuggestions();
       resetFacilityFields();

      amrSelect.querySelector(".selected-value").textContent =
        option.textContent;

      if (validation) {
        await validation.revalidateField("#amr-facility-hcp");
      }
    });
  });
}

if (facilityStateInput && facilityStateDropdown) {
  facilityStateDropdown.querySelectorAll("li").forEach(option => {
    option.addEventListener("click", async () => {

      facilityStateInput.value = option.dataset.value;

      facilityStateDropdown
        .closest(".custom-select")
        .querySelector(".selected-value")
        .textContent = option.textContent;

      if (validation) {
        await validation.revalidateField("#facility-state-hcp");
      }
    });
  });
}
